import { getRandomInt } from './number';

function pickRandomArrayElement<T>(array: T[]): T {
  const index = getRandomInt(0, array.length - 1);

  return array[index];
}

export { pickRandomArrayElement };
